import { RecordColorEnum } from '../../../shared/enums/record-color.enum';
import { PolicyStatusEnum } from '../enums/policy-status.enum';

/**
 * Maps the status value to a color value which is used to style the record pill in the UI
 */
export function policyStatusToColor(status: PolicyStatusEnum): string {
	switch (status) {
		case PolicyStatusEnum.ACTIVE:
			return RecordColorEnum.GREEN;

		case PolicyStatusEnum.INACTIVE:
			return RecordColorEnum.SLATE;

		default:
			return RecordColorEnum.DEFAULT;
	}
}
